export default {
  title01: "Météo actuelle ",
  title02: "24 Heures",
  title03: "Voir les prévisions météo sur 10 jours",
  title04: "IQA",
  title05: "Voir toutes les informations",
  title06: "Lever et coucher du soleil",
  title07: "Phase de la lune",
  title08: "La prochaine pleine lune",
  title09: "La prochaine nouvelle lune",
  title10: "JOUR",
  title11: "NUIT",
  title12: "Lever du soleil",
  title13: "Coucher du soleil",
  title14: "Lever de la lune",
  title15: "Coucher de la lune",
  title16: "Source",
  title17: "Début",
  title18: "Fin",
  title19: "Utiliser la localisation actuelle",
  title20: "Rechercher la ville",
  title21: "Température ressentie",
  title22: "Ressenti à l'ombre",
  title23: "Maintenant",
  title24: "Aujourd'hui",
  title25: "DIM",
  title26: "LUN",
  title27: "MAR",
  title28: "MER",
  title29: "JEU",
  title30: "VEN",
  title31: "SAM",
  title32: "Chargement...",
  title33: "Maintenant",
  title34: "Horaire",
  title35: "Quotidien",
  title36: "Soleil & Lune",
  title37: "Qualité de l'Air",
  title38: "Contacter : xlf550402@gmail.com",
  title39: "Accord de Confidentialité",
  title40: "Droits d'Auteur © comfortweather.com 2020 - 2025. Tous droits réservés.",
  title41: "Données fournies par",
  title42: "Max",
  title43: "Min",
  title44: "Accepter",
  title45:
    "Merci d'utiliser ComfortWeather ! Pour mieux protéger vos droits et intérêts légaux, veuillez lire attentivement la ",
  title46: "Politique de Confidentialité",
  title47: " avant utilisation.",
  title48: "",
  title49: "Contacter : xyjph123@gmail.com",
  title50: "Droits d'Auteur © 24hweather.com 2020 - 2025. Tous droits réservés.",
  title51:
    "Merci d'utiliser 24hweather ! Pour mieux protéger vos droits et intérêts légaux, veuillez lire attentivement la ",
};
